export default class Account {
  constructor(account = {}) {
    this.id = account.id || null
    this.company_name = account.company_name || ''
    this.registration_number = account.registration_number || ''
    this.gst_number = account.gst_number || ''
    this.po_number = account.po_number || ''
    this.billing_email = account.billing_email || ''
    this.on_trial = account.on_trial || false
    this.expires_at = account.expires_at || null
    this.address = account.address || {
      street: '',
      suburb: '',
      city: '',
      province: '',
      post_code: '',
      country_id: '',
    }
    this.subscription = account.subscription || {
      plan: {}
    }
  }

  static mutations() {
    return {
      setAccount: (state, account) => state.account = new Account(account),
      clearAccount: (state, account) => state.account = new Account(),
      updateCompanyName: (state, payload) => state.account.company_name = payload,
      updateRegNumber: (state, payload) => state.account.registration_number = payload,
      updateGstNumber: (state, payload) => state.account.gst_number = payload,
      updatePoNumber: (state, payload) => state.account.po_number = payload,
      updateBillingEmail: (state, payload) => state.account.billing_email = payload,
      updateStreet: (state, payload) => state.account.address.street = payload,
      updateCity: (state, payload) => state.account.address.city = payload,
      updateSuburb: (state, payload) => state.account.address.suburb = payload,
      updateProvince: (state, payload) => state.account.address.province = payload,
      updatePostCode: (state, payload) => state.account.address.post_code = payload,
      updateCountry: (state, payload) => state.account.address.country_id = payload,
    }
  }
}
